import { render, staticRenderFns } from "./NotificationRuleActions.vue?vue&type=template&id=ff5f7684"
import script from "./NotificationRuleActions.vue?vue&type=script&lang=ts"
export * from "./NotificationRuleActions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports